import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { Globe, LogOut, LayoutDashboard, Server, Shield, Sun, Moon, UtensilsCrossed, AppWindow } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
  const { lang, toggleLang, t } = useLanguage();
  const { user, logout, isAdmin, isActive } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="container flex items-center justify-between">
        <Link to="/" className="navbar-logo">
          <div className="logo-icon">
            <Server size={20} color="white" />
          </div>
          Homepage
        </Link>

        <div className="navbar-nav">
          {user ? (
            <>
              {isActive && (
                <>
                  <Link to="/summary" className="navbar-link">
                    <LayoutDashboard size={18} /> {t('summaryDashboard')}
                  </Link>
                  <Link to="/servers" className="navbar-link">
                    <Server size={18} /> {t('servers')}
                  </Link>
                  <Link to="/widgets" className="navbar-link">
                    <LayoutDashboard size={18} /> {t('widgets')}
                  </Link>
                  <Link to="/rt-system" className="navbar-link">
                    <UtensilsCrossed size={18} /> RT System
                  </Link>
                  <Link to="/app-software" className="navbar-link">
                    <AppWindow size={18} /> Apps & Software
                  </Link>
                </>
              )}
              {isAdmin && (
                <>
                  <Link to="/users" className="navbar-link">
                    <Shield size={18} /> {t('users')}
                  </Link>
                  <Link to="/admin" className="navbar-link">
                    <Shield size={18} /> {t('adminDashboard')}
                  </Link>
                </>
              )}
              <button onClick={handleLogout} className="navbar-button">
                <LogOut size={18} /> {t('logout')}
              </button>
            </>
          ) : (
            <Link to="/login" className="navbar-button navbar-button-primary">{t('login')}</Link>
          )}

          <button 
            onClick={toggleTheme} 
            className="btn btn-outline flex items-center gap-2" 
            style={{ padding: '0.5rem 1rem' }}
            title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>

          <button onClick={toggleLang} className="btn btn-outline flex items-center gap-2" style={{ padding: '0.5rem 1rem' }}>
            <Globe size={18} /> {lang === 'ar' ? 'EN' : 'عربي'}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
